import { useAppStateContext } from '../../AppStateProvider/AppStateProvider';
import {useState} from "react";
import {CodecsTestModal} from "./CodecsTestModal/CodecsTestModal";
import {CodecsTestSuccess} from "./CodecsTestSuccess/CodecsTestSuccess";
import {CodecsTestFailed} from "./CodecsTestFailed/CodecsTestFailed";

export function CodecsTest() {
    const { state } = useAppStateContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    return (
        <>
            <CodecsTestModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                audioCodecTestStatus={state.audioCodecTestSuccessful}
                audioCodecTestReport={state.audioCodecTestReport}
                videoCodecTestStatus={state.videoCodecTestSuccessful}
                videoCodecTestReport={state.videoCodecTestReport}
            />
            {state.audioCodecTestSuccessful && state.videoCodecTestSuccessful ? (
                <CodecsTestSuccess openModal={() => setIsModalOpen(true)} />
            ) : (
                <CodecsTestFailed openModal={() => setIsModalOpen(true)} />
            )}</>);
}
